import type { Vehicle } from '@cobliteam/common-types';

/** Human-facing label. Mirrors the format used by MultiSelectVehicles' VehicleItem. */
export const formatVehicleLabel = (vehicle: Vehicle): string => {
  const licensePlate = vehicle.licensePlate ?? '';
  const brand = vehicle.model?.brand ? `- ${vehicle.model.brand}` : '';
  const model = vehicle.model?.name ? ` ${vehicle.model.name}` : '';
  const alias = vehicle.alias ? ` (${vehicle.alias})` : '';
  return `${licensePlate} ${brand} ${model}${alias}`.replace(/\s+/g, ' ').trim();
};
